<nav class="navbar-main fixed-top shadow-sm">
    <div class="row">
      <div class="col-4 col-md-2 navbar-img">
        <img src="../../../../assets/images/logos/logo-virya.png" alt="" height="60">
      </div>
      <div class="col-4 col-md-8 d-flex justify-content-md-center align-items-center">
        <div class="environnement-texte">{{envtest}}</div>
        <a class="navbar-brand mx-auto"
           href="/">
          SUNSMART
        </a>
        <div ngbDropdown class="btn-group" (openChange)="onOpenNotification($event)">
          <a 
            class="notification bi bi-info-circle-fill" 
            title="Notifications"
            ngbDropdownToggle>
          </a>
        
          <div ngbDropdownMenu class="dropdown-menu">
            <ng-container *ngFor="let notification of notifications; let i = index">
              <div ngbDropdownItem class="dropdown-item" [ngClass]="{ 'alt-background': i % 2 === 1 }">
                <div class="row no-gutters align-items-start">
                  <div class="text-param col-9">
                    {{ notification.text }}
                  </div>
                  <div class="col-3 text-end small">
                    {{ notification.date }}
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          
        </div>
        
        <a class="lien-parametre bi bi-gear-fill" title='Paramètres' [routerLink]="['/parametres/famille/', famille]" *ngIf="user.admin"></a>
        <a class="lien-statistiques bi bi-bar-chart-fill" title='Statistiques' [routerLink]="['/statistiques']" *ngIf="user.admin"></a>
        <a class="lien-utilisateurs bi bi-people-fill" title='Utilisateurs' [routerLink]="['/utilisateurs/list']" *ngIf="user.admin"></a>

      </div>
      <div class="col-4 col-md-2 d-flex justify-content-center align-items-center" *ngIf="user">
          <ul class="navbar-nav">
            <li class="nav-item" ngbDropdown container="body">
              <div class="user-pp" ngbDropdownToggle>{{user.getInitiales()}}</div>
              <div ngbDropdownMenu class="dropdown-menu">
                <button ngbDropdownItem (click)="authService.logOut()">Se déconnecter</button>
              </div>
            </li>
          </ul>
        </div>
    </div>
</nav>
